export default "__VITE_ASSET__c459f455__"